<template>
  <article class="d-flex flex-column justify-center align-center pt-4 oferta-article">
    <a :href="link" target="_blank">
      <div class="indicador-icon text-center">
        <v-icon color="#332de6" size="80">{{icon}}</v-icon>
      </div>
      <h5 class="oferta-title app-subtitle">{{title}}</h5>
      <div class="oferta-text">{{text}}</div>
    </a>
  </article>
</template>

<script>
export default {
  props: {
    link: String,
    icon: String,
    title: String,
    text: String
  }
}
</script>

<style scoped>
.oferta-article a {
  text-decoration: none;
  color: black;
}

.oferta-article:hover{
  color: #fe5c82 !important;
}
.oferta-title {
  color: #332de6;
  font-size: 24px;
  padding: 1rem;
}


.oferta-article:hover .oferta-title{
  color: #fe5c82 !important;
}
.oferta-article:hover .oferta-text{
  color: #fe5c82 !important;
}


</style>